/**
 * pwaManifest — swap the `<link rel="manifest">` href based on the current
 * route so the public site installs as "Surveys2CAD" and /admin installs as
 * "S2C Admin", without two independent SPAs.
 *
 * Also updates the iOS app title meta so home-screen label matches the scope.
 */

const ADMIN_MANIFEST = "/admin-manifest.webmanifest";
const SITE_MANIFEST = "/site-manifest.webmanifest";
const ADMIN_TITLE = "S2C Admin";
const SITE_TITLE = "Surveys2CAD";

function isAdminRoute(pathname) {
    return pathname.startsWith("/admin");
}

function apply() {
    const link = document.getElementById("pwa-manifest");
    const titleMeta = document.getElementById("apple-title");
    if (!link) return;
    const onAdmin = isAdminRoute(window.location.pathname);
    const href = onAdmin ? ADMIN_MANIFEST : SITE_MANIFEST;
    // Only touch the DOM when the manifest actually changes to avoid
    // forcing mobile browsers to re-parse on every client-side navigation.
    if (link.getAttribute("href") !== href) {
        link.setAttribute("href", href);
    }
    if (titleMeta) {
        const title = onAdmin ? ADMIN_TITLE : SITE_TITLE;
        if (titleMeta.getAttribute("content") !== title) {
            titleMeta.setAttribute("content", title);
        }
    }
}

export function initPwaManifestSwap() {
    if (typeof window === "undefined") return;
    apply();
    // React-Router navigations don't fire `popstate` for `pushState`; patch it
    // so the manifest swap is in sync after client-side nav.
    const origPush = window.history.pushState;
    const origReplace = window.history.replaceState;
    window.history.pushState = function (...args) {
        const r = origPush.apply(this, args);
        apply();
        return r;
    };
    window.history.replaceState = function (...args) {
        const r = origReplace.apply(this, args);
        apply();
        return r;
    };
    window.addEventListener("popstate", apply);
}
